<template>
    <div class="root">
        <slot name="top" />
        
        <brick-circle-base :draggable="draggable">
            <div class="brick-icon" >
                <slot name="icon" />
            </div>
        </brick-circle-base>

        <div class="text-center">
            <label>{{name}}</label>
        </div>
    </div>
</template>

<script>
import BrickCircleBase from "@modules/JourneyBuilder/Components/Patterns/BrickCircleBase";
import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';

export default {
    name: "base-composable-checkpoint",
    components: {
        BrickCircleBase
    },
    mixins: [permissionsMixin],
    props: {
        draggable: {
            type: Boolean,
            required: true
        },
        
        name: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped lang="scss">
@import "~@modules/JourneyBuilder/Style/Shared/colors.scss";

.root {
    width: 33%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.brick {
    width: 4rem;
    height: 4rem;
}
</style>